module.exports = __webpack_public_path__ + "img/samsung-next-logo.b465484b.png";